module.exports = __webpack_public_path__ + "static/whatdoiget-30a20659466c3e4f0ab437fe30d6e104.jpeg";